import { defineMessages } from '@approvalmax/utils';

export const messages = defineMessages('components.PaymentDetailsAudit', {
    createdBy: 'Created by {name}',
    modifiedBy: 'Last updated by {name}',
    noUpdatesYet: 'No updates since creation.',
});
